import Marquee from "@/components/ui/Marquee";

const NewsTicker = () => {
  return <Marquee>🎉 歡慶網路商店上線，🚚 全店消費滿 $400 即享免運優惠！!</Marquee>;
};

export default NewsTicker;
